import { useUserStore } from "@/stores/user";
import {
  COMPANY_ACCOUNT_DISABLED_ALERT_KEY,
  PENDING_COMPANY_EMAIL_INVITE_TOKEN_KEY,
  PENDING_SUBSCRIPTION_INVITE_SLUG_KEY,
} from "@/constants/subscriptionInvite";

/** Must match Rails `Authentication#reject_disabled_company_user!`. */
export const COMPANY_ACCOUNT_DISABLED_API_MESSAGE = "Account is disabled.";

/** Clear Pinia + invite session keys; set message for HomeView after Cognito logout redirect. */
export function clearCompanyAppSessionAndSetDisabledAlert(): void {
  const store = useUserStore();
  store.clearStore();
  store.setToken("");
  sessionStorage.removeItem(PENDING_SUBSCRIPTION_INVITE_SLUG_KEY);
  sessionStorage.removeItem(PENDING_COMPANY_EMAIL_INVITE_TOKEN_KEY);
  sessionStorage.setItem(
    COMPANY_ACCOUNT_DISABLED_ALERT_KEY,
    "Your account has been disabled. If you need access, contact your company administrator."
  );
}

export function axiosResponseIsAccountDisabled(data: unknown): boolean {
  if (!data || typeof data !== "object") return false;
  const e = (data as { errors?: unknown }).errors;
  return e === COMPANY_ACCOUNT_DISABLED_API_MESSAGE;
}

export function apolloNetworkResultIsAccountDisabled(result: unknown): boolean {
  if (!result || typeof result !== "object") return false;
  const r = result as { errors?: unknown };
  return r.errors === COMPANY_ACCOUNT_DISABLED_API_MESSAGE;
}
